export const CONFLUENCY_COLORS = ['#BFF5FB', '#80D0D8', '#2CB1BC', '#F3C968', '#FF8F4F']
